import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/blog/[slug]/BlogArticleDynamic.tsx");
